import React from "react"
import { NavLink } from "react-router-dom"
import styled from "@emotion/styled"
import * as color from "@nvdb-rapport/shared/src/color"

export default function Nav() {
  return (
    <nav>
      <NavList>
        <StyledNavLink to="/arbeid" activeClassName="selected">
          <li>Arbeid med veglister</li>
        </StyledNavLink>

        <StyledNavLink to="/generer" activeClassName="selected">
          <li>Generer veglister for publisering</li>
        </StyledNavLink>
      </NavList>
    </nav>
  )
}

const NavList = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  background-color: lightgrey;
  border-top: 1px solid var(--brand-color);
  border-bottom: 1px solid var(--brand-color);
`

const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  transition: all 100ms ease-in-out;

  padding: 1.2rem;
  width: 300px;
  text-align: center;
  border-left: 1px solid var(--brand-color);

  &:last-child {
    border-right: 1px solid var(--brand-color);
  }

  &.selected {
    background-color: ${color.gray600};
    color: ${color.gray100};
  }
  &:hover {
    background-color: ${color.gray500};
    color: white;
  }
`
